import { createFileRoute } from "@tanstack/react-router";
import { AdminPartnersPage } from "@/components/admin/AdminPartnersPage";

export const Route = createFileRoute("/_authenticated/admin/partners")({
  component: AdminPartnersPage,
  head: () => ({
    meta: [
      { title: "Partner Engagement — Admin" },
      { name: "description", content: "Per-partner engagement: profile views, unique visitors, saves and outbound clicks." },
      { name: "robots", content: "noindex,nofollow" },
    ],
  }),
});
